import { Link } from 'react-router-dom';

export default function StatsCTA() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200 p-8 md:p-10">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center mb-8">
            {[
              { value: '10,000+', label: '高清影片' },
              { value: '50+', label: '分类覆盖' },
              { value: '99.9%', label: '稳定可用' },
              { value: '24h', label: '实时更新' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</div>
                <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <h3 className="text-lg font-semibold text-foreground-950 mb-3">
              找不到想看的电影？
            </h3>
            <p className="text-sm text-foreground-600 mb-5 max-w-md mx-auto">
              777影院汇集7777影院、777777影院、77777影院、7777777影院等多个数字变体入口，确保您总能找到可用链接
            </p>
            <Link
              to="/category/dongzuo"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-movie-line"></i>
              立即浏览
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}